// @material-ui/icons

import Login from "views/Website/Entry/Login";
import LandingPage from "views/Website/LandingPage/LandingPage";

var webRoutes = [
  {
    path: "/signin",
    component: Login,
    layout: process.env.REACT_APP_EXASPACES_WEBSITE
  },
  {
    path: "",
    component: LandingPage,
    layout: process.env.REACT_APP_EXASPACES_WEBSITE
  },
];
export default webRoutes;
